import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { InputBoxModule } from 'app/shared/components/input-box/input-box.module';
import { ModalModule } from 'app/shared/components/modal/modal.module';
import { NoteFormComponent } from './note-form.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputBoxModule,
    ButtonModule,
    ModalModule,
  ],
  declarations: [NoteFormComponent],
  exports: [NoteFormComponent],
})
export class NoteFormModule {}
